// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"687a3599","367":"35190c66","453":"b21a91d2","551":"0326c224","640":"346b4b0e","828":"33bc0170"}[chunkId] + ".chunk.js";
};